const PERSONAL_EMAIL_DOMAINS = [
  "@gmail.",
  "@yahoo.",
  "@outlook.",
  "@icloud.",
  "@hotmail.",
  "@aol.",
  "@me.",
  "@live.",
  "@mail.",
  "@comcast.",
  "@att.",
  "@msn.",
  "@protonmail.",
  "@ymail.",
  "@usa.",
  "@gmx.",
  "@mac.",
  "@rocketmail.",
  "@cox.",
  "@sbcglobal.",
  "@bellsouth.",
  "@contractor.",
  "@verizon.",
  "@zoho.",
  "@charter.",
  "@consultant.",
  "@email.",
  "@yandex.",
  "@earthlink.",
  "@execs.",
  "@optonline.",
  "@twc.",
  "@zohomail.",
  "@accountant.",
  "@cableone.",
  "@my.",
  "@aim.",
  "@bccto.",
  "@netzero.",
  "@163.",
  "@angelic.",
  "@bellair.",
  "@chef.",
  "@frontier.",
  "@juno.",
  "@mindspring.",
  "@netscape.",
  "@q.",
  ".edu",
];

export default function isPersonalEmail(email: string) {
  return PERSONAL_EMAIL_DOMAINS.some((personalEmailDomain) =>
    email.includes(personalEmailDomain),
  );
}
